import { render, staticRenderFns } from "./CompanyMobileGroupOrdered.vue?vue&type=template&id=6cb505c8"
import script from "./CompanyMobileGroupOrdered.vue?vue&type=script&lang=js"
export * from "./CompanyMobileGroupOrdered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports